import { render } from "./EditMultiLabelDialog.vue?vue&type=template&id=165d6359&scoped=true"
import script from "./EditMultiLabelDialog.vue?vue&type=script&lang=js"
export * from "./EditMultiLabelDialog.vue?vue&type=script&lang=js"

import "./EditMultiLabelDialog.vue?vue&type=style&index=0&id=165d6359&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165d6359"]])

export default __exports__